import React from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { base } from "../../constants/base";
import { handleLogout } from "../../redux/slices/authSlice";

const AdminHeader = () => {
  const user = useSelector((state) => state?.AuthSlice?.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogoutHere = async () => {
    dispatch(handleLogout());
    navigate("/signin");
  };

  return (
    <nav className="navbar admin-header navbar-expand-lg">
      <div className="container-fluid px-4">
        <Link className="navbar-brand" to="/admin/dashboard">
          <img src="/images/logo.png" width="30px" alt="LOGO" />
          <span className="admin-brand-text">ISIT Admin</span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#adminNavbar"
          aria-controls="adminNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="adminNavbar">
          <ul className="navbar-nav ms-auto align-items-center header-nav-hidden-on-mobile">
            <div className="dropdown admin-dropdown">
              <div
                className="admin-dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="admin-user-info">
                  <span className="admin-user-name">{user?.name}</span>
                  <span className="admin-user-role">Super Admin</span>
                </div>

                {user?.images?.[0]?.path ? (
                  <img
                    src={`${base.imageUrl}${user?.images[0]?.path}`}
                    alt="Admin"
                    className="admin-avatar"
                  />
                ) : (
                  <img
                    src="/images/user-demo.jpg"
                    alt="Admin"
                    className="admin-avatar"
                  />
                )}
              </div>

              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <Link className="dropdown-item" to="/admin/dashboard">
                    <i className="fa-solid fa-gauge me-2"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/admin/settings">
                    <i className="fa-solid fa-gear me-2"></i> Settings
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item text-danger"
                    onClick={handleLogoutHere}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
                  </a>
                </li>
              </ul>
            </div>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default AdminHeader;
